import React from 'react';
import { Home } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

/* Shared top brand strip — "#ARSH | IMPERIUM CORE".
   When mounted on any route OTHER than '/', a small Home icon appears on
   the left so the user can always return to the home dial. The centered
   title stays centered because the icon is absolutely positioned. */
export const ArshHeader = ({ right = null } = {}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const showHome = location.pathname !== '/';

  return (
    <div className="relative flex items-center justify-center gap-3 py-3 safe-top-margin" data-testid="arsh-header">
      {showHome && (
        <button
          type="button"
          onClick={() => navigate('/')}
          aria-label="Home"
          data-testid="arsh-header-home"
          className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full border border-[#D4AF37]/30 active:scale-95 transition-transform"
          style={{
            background: 'rgba(212,175,55,0.06)',
            boxShadow: '0 0 8px rgba(212,175,55,0.18)',
          }}
        >
          <Home size={15} style={{ color: '#D4AF37' }} />
        </button>
      )}
      <div className="w-8 h-[1px] bg-gradient-to-r from-transparent to-[#D4AF37]/40" />
      <span className="font-['Cormorant_Garamond'] text-lg font-light tracking-wider">
        <span className="text-[#D4AF37]">#ARSH</span>
        <span className="text-white/15 mx-2">|</span>
        <span className="font-['Outfit'] text-[8px] uppercase tracking-[0.25em] text-white/20">Imperium Core</span>
      </span>
      <div className="w-8 h-[1px] bg-gradient-to-l from-transparent to-[#D4AF37]/40" />
      {right && <div className="absolute right-3 top-1/2 -translate-y-1/2">{right}</div>}
    </div>
  );
};
